"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentRow = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const grid_1 = require("antd/es/grid");
exports.ContentRow = (_a) => {
    var { leftSlot, rightSlot } = _a, rowProps = tslib_1.__rest(_a, ["leftSlot", "rightSlot"]);
    return (React.createElement(grid_1.Row, Object.assign({ type: 'flex', align: 'middle' }, rowProps),
        React.createElement(grid_1.Col, { span: 12 }, leftSlot),
        React.createElement(grid_1.Col, { span: 12 }, rightSlot)));
};
//# sourceMappingURL=ContentRow.js.map